import React, { useEffect, useState } from "react";
import { Download, Share } from "lucide-react";

const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone;
const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);

export default function InstallAppButton() {
  const [prompt, setPrompt] = useState(null);
  const [showIosHint, setShowIosHint] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  if (isStandalone() || (!prompt && !isIOS())) return null;

  const install = async () => {
    if (prompt) { prompt.prompt(); await prompt.userChoice; setPrompt(null); }
    else setShowIosHint((v) => !v);
  };

  return (
    <div className="mt-4">
      <button data-testid="install-app-btn" onClick={install} className="flex w-full items-center justify-center gap-2 rounded-3xl border border-emerald-300/30 bg-emerald-400/10 py-3 text-sm font-semibold text-emerald-100 transition-colors hover:bg-emerald-400/20">
        <Download className="h-4 w-4" /> Instalar app no celular
      </button>
      {showIosHint && (
        <p data-testid="install-ios-hint" className="mt-2 flex items-center justify-center gap-1 text-center text-xs text-emerald-100/70">
          Toque em <Share className="h-3.5 w-3.5" /> Compartilhar e depois em "Adicionar à Tela de Início".
        </p>
      )}
    </div>
  );
}
